import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import Checkbox from 'src/common/components/Checkbox';
import getClassNames from 'src/common/utils/getClassNames';
import getSnoozeStatus from 'src/common/utils/getSnoozeStatus';
import SnoozeDates from './SnoozeDates';
import styles from './ListingCard.module.scss';

type Props = {
  active: boolean;
  underReview: boolean;
  checked: boolean;
  onChange: (checked: boolean) => void;
  snoozeStartDate: string | null;
  snoozeEndDate: string | null;
};

const Header: FC<Props> = ({
  active,
  underReview,
  checked,
  onChange,
  snoozeStartDate,
  snoozeEndDate,
}) => {
  const [t] = useTranslation('admin-listings');
  const { snoozeActive } = getSnoozeStatus(snoozeStartDate, snoozeEndDate);

  const getTitle = () => {
    if (underReview) return t('landing-page--under-review');
    if (active && !snoozeActive) return t('landing-page--published');
    if (active && snoozeActive) return t('landing-page--snoozed');
    return t('landing-page--unpublished');
  };

  return (
    <div className={styles.header}>
      <div className={getClassNames(
        styles,
        'status',
        classNames({
          underReview,
          active: active && !underReview,
          snoozeActive: active && snoozeActive,
        }),
      )}
      >
        <span />
        {getTitle()}
        <SnoozeDates
          active={active}
          snoozeStartDate={snoozeStartDate}
          snoozeEndDate={snoozeEndDate}
        />
      </div>
      <Checkbox checked={checked} onChange={onChange} />
    </div>
  );
};

export default Header;
